import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { userSelectors } from '../../../../../../store/modules/user';
import {
  videoFolderActions,
  videoFolderSelectors
} from '../../../../../../store/modules/videoFolder';

const useStaffDuplicate = (projectId: string) => {
  const dispatch = useDispatch();
  const isUserStaff = useSelector(userSelectors.selectIsStaffUser);
  const isPending = useSelector(state =>
    videoFolderSelectors.selectProjectDuplicateStatus(state, projectId)
  );

  const canDuplicate = isUserStaff;

  const handleDuplicate = useCallback(
    () => dispatch(videoFolderActions.duplicateProject({ projectId })),
    [projectId]
  );

  return [isPending, canDuplicate, handleDuplicate] as const;
};

export default useStaffDuplicate;
